<template>
    <div>
        <div id="conversation">
            <ChatMenu class="conv-menu" @add-group="(value) => addNewChatChange(value)" />
            <ChatViewer
                v-if="!addNewChat && !!selectedChat"
                class="conv-viewer"
                :new-group="addNewChat"
                :visible="visible"
                :default-message="lastDefaultMessage"
            />
            <addNewChat
                v-if="addNewChat"
                :addUserInGroup="addUserInGroup"
                :addNewUserGroupAgents="addNewUserGroupAgents"
                @close="addNewChat = false"
            />
            <ThreadSummaryChat class="conv-sum" v-if="$_.get(selectedChat, 'meta.chatType') === chatTypes.THREAD" />
            <DepartmentSummaryChat
                class="conv-sum"
                v-if="$_.get(selectedChat, 'meta.chatType') === chatTypes.DEPARTMENT"
            />
            <TeamSummaryChat class="conv-sum" v-if="$_.get(selectedChat, 'meta.chatType') === chatTypes.TEAM" />
            <GroupThreadSummaryChat
                @add-user="(agents) => addNewUserGroup(agents)"
                class="conv-sum"
                v-if="$_.get(selectedChat, 'meta.chatType') === chatTypes.GROUP_THREAD"
            />
        </div>
    </div>
</template>

<script>
import { mapActions, mapGetters, mapMutations, mapState } from "vuex";
import { log2 } from "../../../utils/log2";
import ChatMenu from "./ChatMenu";
import ChatViewer from "./ChatViewer";
import ThreadSummaryChat from "./ThreadSummaryChat";
import TeamSummaryChat from "./TeamSummaryChat";
import GroupThreadSummaryChat from "./GroupThreadSummaryChat";
import DepartmentSummaryChat from "./DepartmentSummaryChat";
import MediaSlide from "./MediaSlide";
import addNewChat from "./addNewChat";
import CHAT_TYPES from "../../../utils/ChatTypes";
import AppBreadCrumb from "../../../components/common/AppBreadCrumb";
import { sendSocketMessage, socketMessageStream } from "../../../utils/socketStream";
import SYSTEM_PUBSUB, { systemMessageStream } from "../../../utils/systemPubSub";
import { filter, first } from "rxjs/operators";

const log = log2("TeamChat");
export default {
    name: "TeamChat",
    components: {
        AppBreadCrumb,
        ChatViewer,
        ThreadSummaryChat,
        DepartmentSummaryChat,
        GroupThreadSummaryChat,
        TeamSummaryChat,
        addNewChat,
        ChatMenu,
        MediaSlide,
    },
    props: {
        visible: {
            type: Boolean,
            default: false,
        },
    },
    data() {
        return {
            loading: true,
            addNewChat: false,
            chatTypes: [],
            addNewUserGroupAgents: [],
            newCreatedChat: {},
            addUserInGroup: false,
            cancels: [],
            lastDefaultMessage: "",
        };
    },
    computed: {
        ...mapState({
            chats: (state) => state.team.chats,
            selectedChat: (state) => state.team.selectedChat,
            site: (state) => state.site.site,
            user: (state) => state.auth.user,
        }),
        ...mapGetters({}),
    },
    methods: {
        ...mapActions({
            selectedChatChange: "team/selectedChatChange",
        }),
        setSelectChat() {
            const selectedTeamChatId = this.$route.query.selectedTeamChatId;
            if (selectedTeamChatId) {
                const maybeChat = this.findChat(selectedTeamChatId);
                if (maybeChat) {
                    this.selectedChatChange(maybeChat);
                }
            }
        },
        clearDefaultMessage() {
            setTimeout(() => {
                this.lastDefaultMessage = null;
            }, 1000);
        },
        directMessage(userId, defaultMessage) {
            const maybeChat = this.findChat(userId);
            if (maybeChat) {
                this.lastDefaultMessage = defaultMessage;
                this.selectedChatChange(maybeChat);
            } else {
                const thread = {
                    agent1: this.user._id,
                    agent2: userId,
                };
                sendSocketMessage("team thread-chat-created", {
                    siteId: this.site._id,
                    thread,
                });
                const chatUpdatedStream = systemMessageStream
                    .pipe(
                        filter((x) => x.type === "CHAT_UPDATED"),
                        first()
                    )
                    .subscribe((x) => {
                        const chat = this.findChat(userId);
                        this.lastDefaultMessage = x.payload?.message;
                        this.selectedChatChange(chat);
                    });

                this.cancels.push(() => {
                    chatUpdatedStream.unsubscribe();
                });
            }
        },

        findChat(userId) {
            const maybeChat = this.chats.find((chat) => {
                if (chat.meta.chatType === CHAT_TYPES.THREAD) {
                    if (chat.meta.thread.agent1._id === userId || chat.meta.thread.agent2._id === userId) {
                        return chat;
                    }
                }
            });
            return maybeChat; // maybeChat'i açıkça döndür
        },
        addNewUserGroup({ agentIds }) {
            this.addNewChat = !this.addNewChat;
            this.addNewUserGroupAgents = agentIds;
            this.addUserInGroup = true;
        },
        addNewChatChange(value) {
            this.addNewChat = value;
            this.addNewUserGroupAgents = [];
            this.addUserInGroup = false;
        },
    },
    async mounted() {
        this.chatTypes = CHAT_TYPES;
        this.dmStarterSub = systemMessageStream
            .pipe(filter((x) => x.type === SYSTEM_PUBSUB.MESSAGE_TYPES.START_AGENT_CHAT))
            .subscribe((data) => {
                console.log("data.payload.userId", data.payload.userId);

                this.directMessage(data.payload.userId, data.payload.message);
            });
        this.setSelectChat();
    },
    beforeDestroy() {
        this.dmStarterSub.unsubscribe();
        this.cancels.forEach((cancel) => cancel());
    },

    watch: {
        selectedChat: {
            handler: function (val) {
                if (val) {
                    //add query params ?selectedTeamChatId=val._id

                    if (this.$route.query.selectedTeamChatId !== val._id) {
                        this.$router.push({
                            query: {
                                selectedTeamChatId: val._id,
                                tabIndex: 6,
                            },
                        });
                    }
                }

                this.addNewChat = false;
            },
        },
        deep: true,
    },
};
</script>

<style lang="scss">
#conversation {
    height: calc(100vh - 150px);
    background-color: #ffffff;
    display: flex;
    justify-content: space-between;
    border-radius: 10px;

    .conv-menu {
        max-width: 20%;
        flex: 0 0 20%;
    }

    .conv-viewer {
        max-width: 60%;
        flex: 0 0 60%;
    }

    .conv-sum {
        max-width: 20%;
        flex: 0 0 20%;
        border: 1px solid #f2f2f2;
        width: 300px;
        overflow: auto;
    }
}
</style>
